import type { JSX } from 'react';
import { formatDayLabel } from '@/components/dashboard/showings/showingsAvailabilityWeek';

interface ShowingsAvailabilityCustomSlotFormProps {
  weekDates: string[];
  date: string;
  time: string;
  disabled: boolean;
  onDateChange: (date: string) => void;
  onTimeChange: (time: string) => void;
  onAdd: () => void;
}

export function ShowingsAvailabilityCustomSlotForm({
  weekDates,
  date,
  time,
  disabled,
  onDateChange,
  onTimeChange,
  onAdd,
}: ShowingsAvailabilityCustomSlotFormProps): JSX.Element {
  return (
    <div className="rounded-xl border border-surface-subtle bg-surface-subtle/20 p-4">
      <p className="text-xs font-semibold uppercase tracking-wide text-text-primary/60">
        Add custom slot
      </p>
      <div className="mt-2 flex flex-wrap items-center gap-2">
        <label className="flex flex-col gap-1 text-xs text-text-primary/70">
          <span className="font-semibold uppercase tracking-wide">Date</span>
          <select
            value={date}
            onChange={(event) => {
              onDateChange(event.target.value);
            }}
            className="min-h-11 rounded-xl border border-surface-subtle bg-white px-3 py-2.5 text-base shadow-sm focus:border-brand-primary focus:outline-none focus:ring-2 focus:ring-brand-primary/20 md:py-2 md:text-sm"
          >
            {weekDates.map((optionDate) => (
              <option key={optionDate} value={optionDate}>
                {formatDayLabel(optionDate)}
              </option>
            ))}
          </select>
        </label>
        <label className="flex flex-col gap-1 text-xs text-text-primary/70">
          <span className="font-semibold uppercase tracking-wide">Time</span>
          <input
            type="time"
            value={time}
            onChange={(event) => {
              onTimeChange(event.target.value);
            }}
            aria-label="Custom slot time"
            className="min-h-11 rounded-xl border border-surface-subtle px-3 py-2.5 text-base shadow-sm focus:border-brand-primary focus:outline-none focus:ring-2 focus:ring-brand-primary/20 md:py-2 md:text-sm"
          />
        </label>
        <button
          type="button"
          className="min-h-11 rounded-full bg-brand-primary px-5 py-2 text-xs font-semibold uppercase tracking-wide text-white shadow-sm transition hover:bg-brand-primary/90 disabled:cursor-not-allowed disabled:opacity-70"
          disabled={disabled}
          onClick={onAdd}
        >
          Add slot
        </button>
      </div>
    </div>
  );
}
